export const selectSignUpState = (state) => {
	return {
		application: state.application,
		entities: state.entities,
	};
};
